import type { LineItem } from "@/interfaces/estimate-detail";
import { estimationSelector } from "@/redux/selectors/estimation.selector";
import { useCallback } from "react";
import { dispatch, useSelector } from "@/redux/store";
import type { IXactimateUserRowPayload, LineItemXactimateMapping } from "@/interfaces/payloads/xactimate";
import estimateProvider from "@/providers/estimate.provider";
import { estimationActions } from "@/redux/actions/estimation.actions";
import { LineSheetsHeaderSection } from "./details-section/LineSheets";
import { Network } from "lucide-react";
import { MappingDisplay } from "../MappingDisplay";

export const MappingDisplayDetails = ({ cat, selCode, lineItem }: { cat?: string; selCode?: string; lineItem?: LineItem }) => {
  const xactimateMapping = useSelector(estimationSelector.lineItemXactimateMapping);

  const onConfirm = useCallback(
    async (mapping: IXactimateUserRowPayload) => {
      const response = await estimateProvider.addUserXactimateMapping({ mapping });
      if (response && response.success && response.mapping && xactimateMapping) {
        const updatedMapping = [
          ...xactimateMapping,
          {
            lineItemId: lineItem?.lineItemId,
            lineItem: lineItem?.lineItem,
            cat: response.mapping.cat,
            sel: response.mapping.variable,
            activity: response.mapping.activity,
            quantity: response.mapping.quantity,
          } as LineItemXactimateMapping,
        ];

        dispatch(
          estimationActions.setEstimationState({
            lineItemXactimateMapping: updatedMapping,
          }),
        );
      }
    },
    [lineItem?.lineItem, lineItem?.lineItemId, xactimateMapping],
  );

  return (
    <div className="my-2 flex flex-col gap-2">
      <LineSheetsHeaderSection title={"Xactimate Codes"}>
        <Network className="h-4 w-4" />
      </LineSheetsHeaderSection>
      <div className="grid max-h-full w-full flex-grow gap-4 px-4 py-2">
        <MappingDisplay cat={cat} selCode={selCode} lineItem={lineItem} onConfirm={onConfirm} />
      </div>
    </div>
  );
};
